﻿import {observable, computed, reaction, extendObservable, toJS} from "mobx";
import _ from 'lodash';
import {toast} from "react-toastify";
import {
    arrayToString, formatarCpf, getByAtribute,
    formatarDataMilisegundos
} from "../../../../utils/formatar";
import EmpregadoService from "../../../../services/EmpregadoService";
import MotivoGeralService from "../../../../services/MotivoGeralService";
import {getNomeFluxosById, getTipoGDVById, motivoContratacaoEnum} from "../../../../utils/enums";
import JustificativaContratacaoService from "../../../../services/JustificativaContratacaoService";
import CargoService from "../../../../services/CargoService";
import ProdutoService from "../../../../services/ProdutoService";
import AreaService from "../../../../services/AreaService";
import SolicitacaoService from "../../../../services/SolicitacaoService";
import moment from "moment";
import TarefaService from "../../../../services/TarefaService";
import MOTService from "../../../../services/MOTService";
import ETTService from "../../../../services/ETTService";
import FluxoService from "../../../../services/FluxoService";
import LotacaoService from "../../../../services/LotacaoService";

export default class FluxoStore {
    @observable prorrogacoesAnteriores;
    @observable loadingProrrogacoesAnteriores;
    @observable promiseCarregarDados;
    @observable solicitacao;
    @observable empregadosSubstituidos;
    @observable justificativasContratacao;
    @observable lotacoes;
    @observable cargos;
    @observable motivosContratacao;
    @observable motivosSubstituicao;
    @observable motivosTerminoAntecipado;
    @observable motivosAtraso;
    @observable motivosDesistenciaAlocacaoETT;
    @observable produtos;
    @observable fatosGeradores;
    @observable usuarioLogado;
    @observable possiveisAcoes;
    @observable observacoes;
    @observable matriculaAprovadoresExtra;
    @observable solicitacaoEtt;
    @observable confirmarAlocacaoETT;
    @observable nomeTarefa;
    @observable nomeFluxo;
    @observable idInstanciaFluxo;
    @observable confirmacaoModalEtt;
    @observable comentarios;
    @observable tarefasFluxo;
    @observable contratos;
    @observable validacoes;
    @observable dataInicioValidacao;
    @observable alertas;
    @observable empregadosFiltrados;
    @observable solicitacaoMudancaPrazo;
    @observable momentDataTerminoAntecipado;
    @observable momentDataProrrogacao;
    @observable dataTerminoProrrogacaoValidacao;
    @observable isContratacaoVigenteOuConcluida;
    @observable dataTerminoAntecipadoValidacao;
    @observable loadingCpfIndicacao;
    @observable solicitacaoSubstituicao;
    @observable etts;
    @observable motivosSubstituicaoCpf;
    @observable loadingCpfMOT;
    @observable produtoVigente;
    @observable alocacoesProdutoMot;
    @observable temContrato;
    @observable evolucaoFluxo;
    @observable fluxoNovo;
    @observable idFluxo;
    @observable isLoadingProduto;
    @observable dadosOk;

    //RHFPP-1020
    @observable tipoEmailContratacao;

    detalhesTarefa;
    quantidadeDiasInicial;

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        this.loadingPanelStore = loadingPanelStore;
        this.modalStore = modalStore;
        this.tituloPaginaStore = tituloPaginaStore;
        this.parametrosGeraisStore = parametrosGeraisStore;
        this.loginStore = loginStore;
        this.solicitacao = {};
        this.possiveisAcoes = [];
        this.empregadosFiltrados = [];
        this.observacoes = "";
        this.nomeTarefa = "";
        this.loadingCpfMOT = false;
        this.nomeFluxo = "";
        this.motivosAtraso = [];
        this.confirmacaoModalEtt = false;
        this.isContratacaoVigenteOuConcluida = false;
        this.resetSolicitacaoMudancaPrazo();
        this.resetSolicitacaoEtt();
        this.resetConfirmarAlocacaoETT();
        this.comentarios = [];
        this.tarefasFluxo = [];
        this.empregadosSubstituidos = [];
        this.produtos = [];
        this.lotacoes = [];
        this.cargos = [];
        this.produtoVigente = null;
        this.etts = [];
        this.motivosContratacao = [];
        this.motivosSubstituicao = [];
        this.motivosSubstituicaoCpf = [];
        this.justificativasContratacao = [];
        this.fatosGeradores = [];
        this.taskIdBpmSubstituicao = null;
        this.solicitacaoSubstituicaoId = null;
        this.usuarioLogado = {
            nome: "",
            gestores: []
        };
        this.contratos = [];
        this.validacoes = [];
        this.alertas = "";
        this.loadingCpfIndicacao = false;
        this.solicitacaoSubstituicao = null;

        this.alocacoesProdutoMot = [];
        this.temContrato = false;
        this.evolucaoFluxo = [];
        this.fluxoNovo = false;

        this.tarefaService = new TarefaService();
        this.solicitacaoService = new SolicitacaoService();
        this.cargoService = new CargoService();
        this.empregadoService = new EmpregadoService();
        this.motivoGeralService = new MotivoGeralService();
        this.motService = new MOTService();
        this.validacaoStore = validationStore;
        this.areaService = new AreaService();
        this.justificativaContratacaoService = new JustificativaContratacaoService();
        this.produtoService = new ProdutoService();
        this.ettService = new ETTService();
        this.fluxoService = new FluxoService();
        this.lotacaoService = new LotacaoService();

        this.promiseCarregarDados = null;

        reaction(
            () => this.solicitacao.indicacoes,
            indicacoes => {
                this.setDadosMOTComoIndicacao();
            }
        );
    }


    // gets de fluxo
    @computed
    get isFluxoSolicitacao (){
        return ["GloboMOTSolicitacaoMOT", "solicitacaoContratacao"].includes(this.nomeFluxo);
    }

    @computed
    get isFluxoEtt (){
        return ["GloboMOTSolicitacaoEtt", "solicitacaoEtt"].includes(this.nomeFluxo);
    }

    @computed
    get isFluxoTerminoAntecipado() {
        return ["GloboMOTSolicitacaoTerminoAntecipado", "solicitacaoTerminoAntecipado", "TerminoAntecipado"].includes(this.nomeFluxo);
    }

    @computed
    get isFluxoProrrogacao() {
        return ["GloboMOTSolicitacaoProrrogacao", "solicitacaoProrrogacao"].includes(this.nomeFluxo);

    }

    // gets de tarefas
    @computed
    get isTarefaHTAvaliacaoSolicitacaoContratacao (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacaoContratacao";
    }
    @computed
    get isTarefaHTAvaliacaoSolicitacao (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacao";
    }

    @computed
    get isTarefaHTAvaliacaoSolicitacaoRTS (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacaoRTS";
    }

    @computed
    get isTarefaHTAvaliacaoSolicitacaoRemuneracao (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacaoRemuneracao";
    }

    @computed
    get isTarefaHTAvaliacaoSolicitacaoDCCH (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacaoDCCH";
    }

    @computed
    get isTarefaHTAvaliacaoSolicitacaoEtt (){
        return this.nomeTarefa === "HT_AvaliacaoSolicitacaoEtt";
    }
    
    @computed
    get isTarefaHTReivindicarConfirmar (){
        return ["HT_ReivindicarConfirmar", "HT_ReivindicarConfirmarIndicado"].includes(this.nomeTarefa);
    }

    @computed
    get isTarefaHTConfirmarAlocacao (){
        return this.nomeTarefa === "HT_ConfirmarAlocacao";
    }

    @computed
    get isTarefaHTConfirmarContratacao (){
        return this.nomeTarefa === "HT_ConfirmarContratacaoETT";
    }

    @computed
    get isTarefaHTConfirmarContratacaoGestorSolicitante() {
        return this.nomeTarefa === "HT_ConfirmarContratacaoGestorSolicitante"
    }
    @computed
    get isTarefaHTAjusteSolicitacao() {
        return this.nomeTarefa === "HT_AjusteSolicitacao"
    }

    @computed get idSolicitacaoExibicao() {
        const solicitacaoEttId = _.get(this.solicitacaoEtt,"idSolicitacaoEtt") ? "/"+ this.solicitacaoEtt.idSolicitacaoEtt : "";
        if (_.get(this.solicitacaoMudancaPrazo, "id")){
            return this.solicitacao.id + solicitacaoEttId +"/TA"+ this.solicitacaoMudancaPrazo.id;
        } else if (_.get(this.detalhesTarefa,"solicitacaoSubstituicao.idSolicitacao")){
            return this.solicitacao.id + solicitacaoEttId +"/SB"+ this.detalhesTarefa.solicitacaoSubstituicao.idSolicitacao;
        } else if (this.solicitacaoEtt.idSolicitacaoEtt) {
            return this.solicitacao.id+"/"+this.solicitacaoEtt.idSolicitacaoEtt;
        } else if (this.solicitacao.id) {
            return ""+this.solicitacao.id;
        } else {
            return "Carregando...";
        }
    }

    @computed
    get quantidadeDias() {
        if(this.novaDataInicialEditavel && this.quantidadeDiasInicial)
            return this.quantidadeDiasInicial;
        if(this.confirmarAlocacaoETT.dataInicioRequerida !== null)
            return (_.get(this, "solicitacao.momentDataTermino") && _.get(this, "confirmarAlocacaoETT.dataInicioRequerida")) ? this.solicitacao.momentDataTermino.diff(this.confirmarAlocacaoETT.dataInicioRequerida, 'days') + 1 : null;
        return (_.get(this, "solicitacao.momentDataTermino") && _.get(this, "solicitacao.momentDataInicio")) ? this.solicitacao.momentDataTermino.diff(this.solicitacao.momentDataInicio, 'days') + 1 : null;
    }

    @computed
    get exibeDetalhamentoCPFDiferente() {
        return !this.solicitacao.solicitacaoExcecao && this.isFluxoEtt && this.indicacaoInformada && (this.isTarefaHTConfirmarAlocacao || this.solicitacaoEtt.cpfDiferenteInformado);
    }

    @computed
    get exibeSolicitanteMudancaPrazo() {
        return this.isFluxoTerminoAntecipado;
    }

    @computed
    get exibeSolicitanteProrrogacao() {
        return this.isFluxoProrrogacao;
    }

    @computed
    get exibeDetalhamentoTerminoAntecipado() {
        return this.isFluxoTerminoAntecipado;
    }

    @computed
    get isAdmEmConfirmacaoContratacaoGestor() {
        return this.loginStore.isPerfilAdministradorLogado && this.isTarefaHTConfirmarContratacaoGestorSolicitante;
    }



    @computed
    get exibePercentualSalarioGlobo() {
        return (!this.loginStore.isAnalistaLogado || this.loginStore.isPerfilRemuneracaoOuDCCH) && this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo && this.solicitacao.cargo.salarioBase && this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get exibeContratosAnterioresEValidacoes() {
        if (this.isFluxoSolicitacao) {
            let result = this.solicitacao.solicitacaoExcecao 
            && (this.isTarefaHTAvaliacaoSolicitacaoRTS || this.isTarefaHTAvaliacaoSolicitacaoRemuneracao || this.isTarefaHTAvaliacaoSolicitacaoDCCH);
            
            if (result) {
                this.carregarCpfMOT("mot");
            }
            return result;
        } if (this.isFluxoEtt) {
            let  result = this.isTarefaHTAvaliacaoSolicitacaoRTS || this.isTarefaHTAvaliacaoSolicitacaoRemuneracao;
            if (result) {
                this.carregarCpfMOT("ett");
            }
            return result;
        } else {
            return false;
        }
    }

    @computed
    get exibeSubtituloIndicacao() {
        return !this.solicitacao.solicitacaoExcecao && !this.isFluxoEtt;
    }

    @computed
    get exibeIndicacaoEtt() {
        return this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get tituloIndicacao() {
        return this.solicitacao.solicitacaoExcecao ? "Indicação" : this.isFluxoEtt ? "Indicação para o processo de seleção" : "Indicações para o processo de seleção";
    }

    @computed
    get exibeAvisoIndicacaoNaoReivindicada() {
        return this.isTarefaHTReivindicarConfirmar;
    }

    @computed
    get novoCpfEditavel() {
        return this.isTarefaHTConfirmarAlocacao;
    }

    @computed
    get indicacaoInformada() {
        return this.solicitacaoEtt && this.solicitacaoEtt.temIndicacao;
    }

    @computed
    get indicacoesSolicitadas() {
        return this.solicitacao.indicacoes ? this.solicitacao.indicacoes.length > 0 : false;
    }

    @computed
    get exibeQuantidadeRecursos() {
        return !this.solicitacao.solicitacaoExcecao && this.isFluxoSolicitacao;
    }

    @computed
    get indicacao() {
        return this.solicitacao.indicacoes ? this.solicitacao.indicacoes[0] : null;
    }

    @computed
    get exibeDetalhamentoDadosMOT() {
        // Condição 1: O fluxo e a tarefa atuais permitem a exibição?
        const isFluxoProrrogacaoOuTermino = this.isFluxoProrrogacao || this.isFluxoTerminoAntecipado;

        // A exibição é permitida para fluxos de ETT (exceto na tarefa de reivindicar com indicação já feita)
        // ou para fluxos de prorrogação e término.
        const fluxoPermiteExibicao = (this.isFluxoEtt && !this.isTarefaHTReivindicarConfirmar) || isFluxoProrrogacaoOuTermino;

        // Condição 2: Existem dados do MOT (CPF) ou a tela permite a edição do CPF?
        // Usando lodash.get para segurança, como é comum no projeto.
        const temDadosOuPodeEditar = !!_.get(this.solicitacaoEtt, 'dadosMot.cpf') || this.permiteEditarCPF;

        return fluxoPermiteExibicao && temDadosOuPodeEditar;
    }

    @computed
    get exibeDetalhamentoAlterarDataInicio() {
        const isTarefaConfirmar = this.isTarefaHTConfirmarContratacao || this.isTarefaHTConfirmarContratacaoGestorSolicitante;
        return this.isFluxoEtt && isTarefaConfirmar && !this.isContratacaoVigenteOuConcluida;
    }

    @computed
    get exibeSalarioExcecao() {
        return (!this.loginStore.isAnalistaLogado || this.loginStore.isPerfilRemuneracaoOuDCCH) && this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get exibeSalarioRequerido() {
        return (!this.loginStore.isAnalistaLogado || this.loginStore.isPerfilRemuneracaoOuDCCH) && this.solicitacaoEtt && this.solicitacaoEtt.salarioDiferente;
    }

    @computed
    get exibeSalarioBase() {
        return !this.loginStore.isAnalistaLogado || this.loginStore.isPerfilRemuneracaoOuDCCH;
    }

    @computed
    get exibeValorAcheCargo() {
        return this.solicitacao.cargo && this.solicitacao.cargo.salarioBase && this.solicitacao.cargo.percentualAche && (!this.loginStore.isAnalistaLogado || this.loginStore.isPerfilRemuneracaoOuDCCH);
    }

    @computed
    get valorAcheExcecao() {
        return this.solicitacao.salarioExcecao && this.solicitacao.salarioExcecao > 0 ? (this.solicitacao.salarioExcecao - this.salarioBaseExcecao) : 0;
    }

    @computed
    get salarioBaseExcecao() {
        return this.solicitacao.salarioExcecao && this.solicitacao.salarioExcecao > 0 ? (this.solicitacao.salarioExcecao * this.percentualBase) : 0;
    }

    @computed
    get exibeValorAcheRequerido() {
        return this.solicitacaoEtt && this.solicitacaoEtt.salarioDiferente && this.solicitacao.cargo.percentualAche && this.exibeSalarioRequerido;
    }

    @computed
    get exibePercentualGDV() {
        return this.solicitacao.cargo && !!this.solicitacao.cargo.percentualGDV;
    }

    @computed
    get exibeGestorSolicitante() {
        return !this.loginStore.isPerfilEttLogado;
    }

    @computed
    get exibeJustificativaExcecao() {
        return !this.loginStore.isPerfilEttLogado && this.isSolicitacaoExcecao;
    }

    @computed
    get exibeDebito() {
        return (!this.isTarefaHTReivindicarConfirmar && !this.isTarefaHTConfirmarAlocacao && !this.isTarefaHTConfirmarContratacao);
    }

    @computed
    get exibeDetalhamentoSalarioDiferente() {

        return !this.loginStore.isAnalistaLogado && !this.isContratacaoVigenteOuConcluida && 
        !this.solicitacao.solicitacaoExcecao && 
         this.isFluxoEtt && !this.isTarefaHTReivindicarConfirmar;
    }

    @computed
    get exibeDetalhesJustificativa() {
        return !this.loginStore.isPerfilEttLogado;
    }

    get exibeEmpregadosSubstituidos() {
        return this.solicitacao.justificativaContratacao && this.solicitacao.justificativaContratacao.motivoContratacao === "SUB"
    }

    @computed
    get tipoGDVString() {
        const stringTipoGDV = this.solicitacao.cargo && this.solicitacao.cargo.tipoGDV && getTipoGDVById(this.solicitacao.cargo.tipoGDV)
        return stringTipoGDV ? "(" + stringTipoGDV.valor.toLowerCase() + ")" : null
    }

    @computed
    get periculosidadeCargo() {
        const periculosidade = this.solicitacao.cargo && this.solicitacao.cargo.possuiPericulosidade;
        return periculosidade && typeof periculosidade === "boolean" ? "Sim" : typeof periculosidade === "boolean" ? "Não" : ""
    }

    @computed
    get insalubridadeCargo() {
        const insalubridade = this.solicitacao.cargo && this.solicitacao.cargo.possuiInsalubridade;
        return insalubridade && typeof insalubridade === "boolean" ? "Sim" : typeof insalubridade === "boolean" ? "Não" : ""
    }

    @computed
    get quantidadeAprovadoresExtraMostrados() {
        const qnt = [];
        this.solicitacao.matriculaAprovadoresExtra.map(empregado => {
            if(empregado !== null) {
                qnt.push(empregado)
            }
        });
        return qnt.length;
    }

    @computed
    get posicaoPrimeiroAprovadorExtra() {
        this.solicitacao.matriculaAprovadoresExtra.map((empregado, index) => {
            if(empregado !== null) {
                return index;
            }
        });
    }

    @computed
    get momentDepoisDataInicio() {
        return this.solicitacao.momentDataInicio ? moment(this.solicitacao.momentDataInicio) : null;
    }

    @computed
    get momentAntesDataTermino() {
        return this.solicitacao.momentDataTermino ? moment(this.solicitacao.momentDataTermino).add(-1, "days") : null;
    }

    @computed
    get percentualSalarioExcecaoEGlobo() {

        const salarioExcecao = this.solicitacao.salarioExcecao;
        const salarioGlobo = this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo;
        const percentualBase = this.solicitacao.cargo && this.solicitacao.cargo.percentualAche ? (100 / (100 + this.solicitacao.cargo.percentualAche)) : 0;
        const salarioBaseExcecao = salarioExcecao && percentualBase > 0 ? (salarioExcecao * percentualBase) : 0;

        // calcular o percentual a partir do salario base de exceção se o cargo tiver percentual de Ache
        return salarioGlobo && salarioExcecao ? 
            (salarioBaseExcecao > 0 ? 
                (salarioBaseExcecao * 100 / salarioGlobo).toFixed(0) + "%" : 
                (salarioExcecao * 100 / salarioGlobo).toFixed(0) + "%" ) : "";
    }

    @computed
    get novaDataInicialEditavel() {
        return this.isTarefaHTConfirmarContratacao;
    }

    @computed
    get salarioDiferenteEditavel() {
        return this.isTarefaHTReivindicarConfirmar || this.isTarefaHTConfirmarAlocacao;
    }

    @computed
    get salarioMin() {
        const salarioGlobo = this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo;
        return salarioGlobo && salarioGlobo * this.parametrosGeraisStore.parametros.smrsgPrctMin / 100.0;
    }

    @computed
    get salarioMax() {
        const salarioGlobo = this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo;
        return salarioGlobo && salarioGlobo * this.parametrosGeraisStore.parametros.smrsgPrctRgl / 100.0;
    }

    @computed
    get exibeRazaoAtraso() {
        return this.isTarefaHTConfirmarContratacaoGestorSolicitante;
    }

    @computed
    get exibeDetalhamentoProrrogacoesRealizadas() {
        return this.isContratacaoVigenteOuConcluida && this.prorrogacoesAnteriores && this.prorrogacoesAnteriores.length > 0;
    }

    @computed
    get getInformarDataInicioDiferente() {
        return this.confirmarAlocacaoETT.informarDataInicioDiferente;
    }

    @computed
    get exibirDescricaoSolicitacaoCentroCustoDebito(){
        if(this.solicitacao.centroCustoDebito && _.get(this.solicitacao.gestorAreaDebito, "nomeArea")) {
            return this.solicitacao.centroCustoDebito + ' ' + this.solicitacao.gestorAreaDebito.nomeArea;
        } else if(this.solicitacao.centroCustoDebito && this.solicitacao.nomeAreaDebito) {
            return this.solicitacao.centroCustoDebito + ' ' + this.solicitacao.nomeAreaDebito;
        } else if(this.solicitacao.centroCustoDebito) {
            return this.solicitacao.centroCustoDebito;
        } else {
            return "";
        }
    }

    get getMomentNovaDataInicio() {
        if(this.confirmarAlocacaoETT.dataInicioRequerida !== null){
            return moment(this.confirmarAlocacaoETT.dataInicioRequerida);
        }else{
            return this.solicitacao.momentDataInicio;
        }

    }

    get getDataInicioAlterada(){
        return this.confirmarAlocacaoETT.dataInicioRequerida;
    }

    @computed
    get totalDiasContratoAtualizado() {
        const momentNovaDataInicio = this.getMomentNovaDataInicio;
        const momentDataTermino = _.get(this, "solicitacao.momentDataTermino");
        return (momentDataTermino && momentNovaDataInicio) ? momentDataTermino.diff(momentNovaDataInicio, 'days') + 1 : null;
    }

    @computed
    get isSolicitacaoExcecao() {
        return this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get exibeContatoEtt() {
        return this.isFluxoEtt
    }

    @computed
    get contatoEttEditavel() {
        return this.isTarefaHTReivindicarConfirmar || this.isTarefaHTConfirmarAlocacao;
    }

    @computed
    get exibeIndicacoes() {
        return (this.indicacaoInformada || this.indicacoesSolicitadas) 
        && (!this.isFluxoEtt || this.isTarefaHTReivindicarConfirmar || this.isTarefaHTConfirmarAlocacao ) 
        && !this.isFluxoProrrogacao && !this.isFluxoTerminoAntecipado;
    }

    @computed
    get exibeDetalhamentoHistorico() {
        return this.comentarios && this.comentarios.length > 0 /*&& !this.loginStore.usuarioLogado.perfilEtt*/
    }

    @computed
    get exibeDadosExtraMOT() {
        return !this.isContratacaoVigenteOuConcluida && !this.isFluxoProrrogacao && !this.isFluxoTerminoAntecipado;
    }

    @computed
    get exibeAprovadoresExtraDetalhamento() {
        return this.modalStore.exibirModal.tipo == "aprovar" && ((this.isTarefaHTAvaliacaoSolicitacaoContratacao && this.isFluxoSolicitacao) || (this.isTarefaHTAvaliacaoSolicitacao && this.isFluxoProrrogacao))
    }

    @computed
    get exibirGestorSolicitante(){
        if(_.get(this.solicitacao, "gestorSolicitante.nome")) {
            const matricula = _.get(this.solicitacao, "gestorSolicitante.matricula") && " (" + this.solicitacao.gestorSolicitante.matricula + ")";
            return this.solicitacao.gestorSolicitante.nome + matricula;
        }else{
            return "";
        }
    }

    @computed
    get permiteEditarCPF() {
        return (this.isTarefaHTReivindicarConfirmar || this.isTarefaHTConfirmarAlocacao) && !this.indicacaoInformada;
    }

    @computed
    get apenasMatriculaAprovadoresExtraValidos() {
        const matriculasValidas = [];
        if(this.solicitacao.matriculaAprovadoresExtra) {
            this.solicitacao.matriculaAprovadoresExtra.map(aprovador => {
                if(aprovador && aprovador.length === 11){
                    matriculasValidas.push(getByAtribute(this.empregadosFiltrados, aprovador, "cpf").matricula);
                } else if(aprovador) {
                    matriculasValidas.push(aprovador);
                }
            });
        }
        return matriculasValidas;
    }

    @computed
    get exibeMigracoesRealizadas() {
        return this.temContrato && this.alocacoesProdutoMot.length > 0;
    }

    @computed
    get percentualBase() {
        return this.solicitacao.cargo && this.solicitacao.cargo.percentualAche ? (100 / (100 + this.solicitacao.cargo.percentualAche)) : 0;
    }

    // gets comuns do novo fluxo
    @computed
    get exibeEvolucaoFluxo() {
        return this.evolucaoFluxo && this.evolucaoFluxo.length > 0;
    }

    @computed
    get isFluxoNovo(){
        return this.fluxoNovo || (this.detalhesTarefa && this.detalhesTarefa.idFluxo && this.detalhesTarefa.idFluxo > 0);
    }
    @computed
    get getIdFluxo(){

        const idFluxo = this.detalhesTarefa && this.detalhesTarefa.idFluxo 
        ? this.detalhesTarefa.idFluxo
        : this.fluxoNovo 
            ? this.idFluxo 
            : null;

        return idFluxo;
    }


    @computed
    get isTipoEmailContratacaoObrigatorio(){
        return this.isFluxoSolicitacao && this.solicitacao.tipoEmailContratacao == null;
    }
    get exibeSelectTipoEmailContratacao(){
        return this.detalhesTarefa && this.isTarefaHTConfirmarContratacaoGestorSolicitante;
    }

    handleDetalhesTarefaByTaskId = (detalhesTarefa) => {
        this.detalhesTarefa = detalhesTarefa;
        this.detalhesTarefa.solicitacao.motivoContratacao = this.detalhesTarefa.solicitacao.justificativaContratacao.motivoContratacao;
        this.setDataMomentInDetalhesTarefa();
        this.checkAprovadoresExtraInDetalhesTarefa();
        this.setSolicitacaoFromDetalhesTarefa();
        this.setPossiveisAcoesFromDetalhesTarefa();
        this.setNomeFluxoETarefaFromDetalhesTarefa();
        this.tituloPaginaStore.setTitulo(getNomeFluxosById(detalhesTarefa.nomeFluxo).valor + " - "+detalhesTarefa.nomeTarefa);
        this.idInstanciaFluxo = detalhesTarefa.idInstanciaFluxo;
        this.idSolicitacao = detalhesTarefa.solicitacaoEtt ? detalhesTarefa.solicitacaoEtt.idSolicitacaoEtt : this.solicitacao.id;
        this.getComentarios();
        this.getTarefasFluxo();
        this.setSolicitacaoEtt(this.detalhesTarefa.solicitacaoEtt);
        this.setSolicitacaoMudancaPrazoFromDetalhesTarefa();
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo(this.solicitacao.id);
        // RHFPP-1020
        this.tipoEmailContratacao = this.solicitacao.tipoEmailContratacao != null ? this.solicitacao.tipoEmailContratacao.toString() : null;
    };

    handleSolicitacaoPorId = (solicitacao, temSolicitacaoEtt, setTitulo) => {
        this.prepararSolicitacao(solicitacao);
        extendObservable(this.solicitacao, solicitacao);
        this.solicitacao = solicitacao;
        this.carregarJustificativasPeloMotivoInicial();
        //this.carregarProdutosPelaJustificativaInicial();
        const params = new URLSearchParams(location.search);
        const idSolicitacaoBpm = params.get('id');
        this.possiveisAcoes =  (idSolicitacaoBpm === null || idSolicitacaoBpm) ? [] : ["FORCE_APPROVE"];
        if(!temSolicitacaoEtt) {
            this.idSolicitacao = this.solicitacao.id;
            this.solicitacaoMudancaPrazo.solicitacaoEttId = this.idSolicitacao;
            this.getComentarios();
            this.getTarefasFluxo();
            if(setTitulo) {
                this.tituloPaginaStore.setTitulo("Detalhamento de solicitação de contratação");
            }
        }
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo(this.solicitacao.id);

    };

    handleSolicitacaoEttById = (solicitacaoEtt, setTitulo, idSolicitacaoMudancaPrazo) => {
        this.setSolicitacaoEtt(solicitacaoEtt);
        if(setTitulo) {
            this.tituloPaginaStore.setTitulo("Detalhamento de contratação");
        }
        this.idSolicitacao = solicitacaoEtt.idSolicitacaoEtt;
        this.solicitacaoMudancaPrazo.solicitacaoEttId = this.idSolicitacao;
        this.solicitacaoMudancaPrazo.id = idSolicitacaoMudancaPrazo;
        this.getComentarios();
        this.getTarefasFluxo();
    };

    handleTempoVigenciaContrato = (tempoVigenciaContrato) => {
        if(tempoVigenciaContrato) {
            this.solicitacao.momentDataInicio = moment(tempoVigenciaContrato.dataInicial);
            this.solicitacao.momentDataTermino = moment(tempoVigenciaContrato.dataFinal);
            this.temContrato = true;
        }
    };

    carregarDadosBasicosUrl(dadosUrl) {
        if (dadosUrl.tipo === "solicitacao") {
            if(dadosUrl.taskIdBpmSubstituicao && dadosUrl.solicitacaoSubstituicaoId) {
                this.taskIdBpmSubstituicao = dadosUrl.taskIdBpmSubstituicao;
                this.solicitacaoSubstituicaoId = dadosUrl.solicitacaoSubstituicaoId;
            }
            this.isContratacaoVigenteOuConcluida = true;

            if(dadosUrl.solicitacaoEttId) {
                this.nomeFluxo = "GloboMOTSolicitacaoEtt";
                this.nomeTarefa = "HT_ConfirmarContratacaoGestorSolicitante";
            } else {
                this.nomeFluxo = "GloboMOTSolicitacaoMOT";
                this.nomeTarefa = "HT_AvaliacaoSolicitacaoDiretor";
            }
        }
    }

    getSolicitacao(dadosUrl, setTitulo = true) {
        let promise = null;
        let carregandoDadosPor = null;
        this.carregarDadosBasicosUrl(dadosUrl);
        if (dadosUrl.tipo === "tarefa") {
            carregandoDadosPor = "taskId";
            promise = this.fluxoService.getSolicitacaoContratacao(dadosUrl.id); 
        } else if (dadosUrl.tipo === "solicitacao") {
            this.fluxoNovo = dadosUrl.isFluxoNovo;
            this.idFluxo = dadosUrl.idFluxo;
            if(dadosUrl.solicitacaoEttId) {
                carregandoDadosPor = "solicitacaoEttId";
                promise = this.fluxoService.carregarDetalhesSolicitacaoByEttId(dadosUrl.solicitacaoEttId);
            } else {
                carregandoDadosPor = "solicitacaoId";
                promise = this.fluxoService.getDetalheSolicitacaoContratacao(dadosUrl.solicitacaoId);
            }
        }

        this.loadingPanelStore.setIsLoading("FluxoLoading", true);

        this.preCarregarDadosExtra(dadosUrl);

        promise.then(response => {
            switch(carregandoDadosPor) {
                case "taskId":
                    this.handleDetalhesTarefaByTaskId(response.data);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
                case "solicitacaoId":
                    this.handleSolicitacaoPorId(response.data, !!dadosUrl.solicitacaoEttId, setTitulo);
                    break;
                case "solicitacaoEttId":
                    this.handleSolicitacaoPorId(response.data.solicitacao, !!dadosUrl.solicitacaoEttId, setTitulo);
                    this.handleSolicitacaoEttById(response.data.solicitacaoEtt, setTitulo, dadosUrl.prorrogacaoId);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
            }
            this.carregarDadosProrrogacoesAnteriores();
            this.carregarDadosMigracoesRealizadas();
            this.carregarDadosExtras(response.data, carregandoDadosPor, dadosUrl);
            this.quantidadeDiasInicial = this.quantidadeDias;
            this.loadingPanelStore.setIsLoading("FluxoLoading", false);
            this.dadosOk= true;
        }).catch(error => {
            this.dadosOk= false;
            this.loadingPanelStore.setIsLoading("FluxoLoading", false);
        });
    }

    //implementados pelos filhos
    carregarDadosExtras = (response, carregandoDadosPor, dadosUrl) => {};

    preCarregarDadosExtra = (dadosUrl) => {};

    carregarDadosMigracoesRealizadas() {
        if(this.solicitacaoEtt.idSolicitacaoEtt) {
            this.alocacoesProdutoMot = [];
            this.solicitacaoService.carregarAlocacoesProdutoMot(this.solicitacaoEtt.idSolicitacaoEtt).then(response => {
                this.alocacoesProdutoMot = response.data.map(item => ({
                    ...item,
                    botaoSincMediaPulse: item.status === "Vigente"
                }));
            }).catch(error => {
            })
        }
    }

    sincronizarMediaPulse(row) {
        const contratoId = row.contratoId;
        this.solicitacaoService.sincronizarMediaPulse(contratoId).then(response => {
            const indexRegistroVigente = this.alocacoesProdutoMot.findIndex(item =>
                item.contratoId === contratoId && item.status === "Vigente"
            );

            if (indexRegistroVigente >= 0) {
                this.alocacoesProdutoMot = this.alocacoesProdutoMot.map((item, index) =>
                    index === indexRegistroVigente
                        ? {
                            ...item,
                            sistemaAlocacao: response.data
                        }
                        : item
                );
            }
            toast.success("Alocação sincronizada com sucesso no MediaPulse.");
        }).catch(() => {
            toast.error("Falha ao sincronizar a alocação no MediaPulse.");
        });
    }

    carregarDadosProrrogacoesAnteriores = () => {
        if(this.solicitacaoEtt.idSolicitacaoEtt) {
            this.loadingProrrogacoesAnteriores = true;
            this.solicitacaoService.prorrogacoesAnteriores(this.solicitacaoEtt.idSolicitacaoEtt).then(response => {
                this.loadingProrrogacoesAnteriores = false;
                this.prorrogacoesAnteriores = response.data;
            }).catch(error => {
                this.loadingProrrogacoesAnteriores = false;
                console.log(error);
            })
        }
    };

    setDataMomentInDetalhesTarefa() {
        this.detalhesTarefa.solicitacao.momentDataInicio = moment(this.detalhesTarefa.solicitacao.dataInicio);
        this.detalhesTarefa.solicitacao.momentDataTermino = moment(this.detalhesTarefa.solicitacao.dataTermino);
        this.dataInicioValidacao = moment(this.detalhesTarefa.solicitacao.dataInicio).format('DD/MM/YYYY');
    }

    setSolicitacaoFromDetalhesTarefa() {
        extendObservable(this.solicitacao, this.detalhesTarefa.solicitacao);
        this.solicitacao = this.detalhesTarefa.solicitacao;
    }

    setPossiveisAcoesFromDetalhesTarefa() {
        extendObservable(this.possiveisAcoes, this.detalhesTarefa.possiveisAcoes);
        this.possiveisAcoes = this.detalhesTarefa.possiveisAcoes;
    }

    setNomeFluxoETarefaFromDetalhesTarefa() {
        this.nomeFluxo = this.detalhesTarefa.definicaoFluxoId;
        this.nomeTarefa = this.detalhesTarefa.definicaoTarefaId;
    }

    setSolicitacaoMudancaPrazoFromDetalhesTarefa() {
        this.solicitacaoMudancaPrazo = this.detalhesTarefa.solicitacaoMudancaPrazo;
        if(_.get(this.solicitacaoMudancaPrazo, "dataTerminoProrrogada")) {
            this.momentDataTerminoAntecipado = moment(this.solicitacaoMudancaPrazo.dataTerminoProrrogada);
            this.setDataTerminoAntecipado(this.momentDataTerminoAntecipado);
        } else {
            this.momentDataTerminoAntecipado = null;
        }
    }

    checkAprovadoresExtraInDetalhesTarefa() {
        if(_.get(this.detalhesTarefa,"solicitacao.matriculaAprovadoresExtra.length", 0) < 1) {
            this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = [""];
        }
    }

    tarefaPermiteAtualizarPayload() {
        return ["HT_SolicitacaoContratacao", "HT_AjusteSolicitacao", "HT_AvaliacaoSolicitacao", "HT_AvaliacaoSolicitacaoContratacao", "HT_ReivindicarConfirmar", "HT_ReivindicarConfirmarIndicado", "HT_ConfirmarAlocacao", "HT_ConfirmarContratacaoETT", "HT_ETTInformaRecurso"].includes(this.nomeTarefa);
    }

    tarefaPrecisaValidarMot() {
        return this.isTarefaHTConfirmarAlocacao || this.isTarefaHTConfirmarContratacao;
    }

    setDadosMOTComoIndicacao(removerCasoContrario = false) {
        if (!this.solicitacaoEtt.cpfDiferenteInformado && this.solicitacaoEtt.indicacao) {
            this.setMotCpf(this.solicitacaoEtt.indicacao.cpf);
            this.setTelefone(this.solicitacaoEtt.indicacao.telefone);
            this.setEmail(this.solicitacaoEtt.indicacao.email);
            this.setNome(this.solicitacaoEtt.indicacao.nome);
        } else if(removerCasoContrario) {
            this.setMotCpf("");
        }
    }

    setMotCpf(value, isNovaDataInicio = false) {
        const dadosMot = this.solicitacaoEtt.dadosMot;
        dadosMot.cpf = value;
        if (value.length === 11 && (this.permiteEditarCPF || this.tarefaPrecisaValidarMot())) {
            this.validarCpfMOT(value, this.setLoadingMOTCpf, this.atualizaDadosMotReivindicacaoContratosAntigo, isNovaDataInicio);
        } else {
            this.alertaValidacaoCPF = [];
            this.obstrucaoValidacaoCPF = [];
        }
    }

    setObservacoes(value) {
        this.observacoes = value;
    }

    setCentroCustoDebito(value) {
        this.solicitacao.centroCustoDebito = value;
        if (value) {
            this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(value).then(response => {
                this.solicitacao.gestorAreaDebito = response.data;
            }).catch(erro => {
                console.log(erro);
            })
        } else {
            this.solicitacao.gestorAreaDebitoId = "";
            this.solicitacao.gestorAreaDebito = {
                "id": 0,
                "matricula": 0,
                "cpf": "",
                "nome": "",
            }
        }
    }

    removerAprovadorExtra(index) {
        this.solicitacao.matriculaAprovadoresExtra[index] = null;
    }

    adicionarAprovadorExtra(index) {
        this.solicitacao.matriculaAprovadoresExtra.splice(index + 1, 0, "");
    }

    setMatriculaAprovadoresExtra(value, option, index) {
        this.solicitacao.matriculaAprovadoresExtra[index] = value;
    }

    filtrarAprovadoresExtra(input, callback) {
        if (input && input.length > 2) {
            const matriculaGestorSolicitante = this.loginStore.usuarioLogado.matricula;

            this.empregadoService.filtrarGestoresPorNh(input).then(response => {
                let gestores = response.data || [];

                if (matriculaGestorSolicitante) {
                    gestores = gestores.filter(aprovador => aprovador.value !== matriculaGestorSolicitante);
                }

                callback(null, {
                    options: gestores.map(aprovador => {
                        return { "value": aprovador.value, "label": aprovador.label };
                    }),
                    complete: false
                });

            }).catch(error => {
                callback(null, {
                    options: [],
                    complete: false
                });
                console.log(error);
            });
        } else {
            callback(null, { options: [], complete: false });
        }
    }
    filtrarAprovadoresExtraDebounce = _.debounce(this.filtrarAprovadoresExtra, 1000);

    carregarLista(tipoDetalhamento, setTitulo) {
        this.getSolicitacao(tipoDetalhamento, setTitulo);
        this.carregarLotacoes();

        this.motivosContratacao = motivoContratacaoEnum;

        this.loadingPanelStore.setIsLoading("dadosBasicosLoading", true);

        const dadosPromise = Promise.all([
            this.motivoGeralService.listMotivoAtraso().then(response => {
                this.motivosAtraso = response.data;
            }),

            this.motivoGeralService.listMotivoTerminoAntecipado().then(response => {
                this.motivosTerminoAntecipado = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoMOTAlocada().then(response => {
                this.motivosSubstituicao = response.data;
            }),
            this.motivoGeralService.listMotivoDesistenciaAlocacaoETT().then(response => {
                this.motivosDesistenciaAlocacaoETT = response.data;
            }),
            this.ettService.list().then(response => {
                this.etts = response.data;
            }),
            this.motivoGeralService.listMotivoSubstituicaoCPF().then(response => {
                this.motivosSubstituicaoCpf = response.data;
            })
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
            console.log(error);
        })
    }

    carregarLotacoes() {
        this.lotacaoService.list().then(response => {
            this.lotacoes = response.data.filter(x => (x.ativo === true && x.empresaGlobo !== null))
        }).catch(error => {
            // No FluxoStore, não temos acesso direto ao formErrorsStore, então apenas logamos o erro.
            console.log(error);
        })
    }

    resetSolicitacaoMudancaPrazo = () => {
        this.solicitacaoMudancaPrazo = {
            razaoAlteracao: "",
            dataTerminoProrrogada: null,
            solicitacaoEttId: this.idSolicitacao
        };
        this.dataTerminoAntecipadoValidacao = null;
        this.dataTerminoProrrogacaoValidacao = null;
    };

    setRazaoTerminoAntecipado = (value) => {
        this.solicitacaoMudancaPrazo.razaoAlteracao = value
    }

    setDataTerminoAntecipado = (value) => {
        let date = value;
        if(date) {
            date = moment(date.format('DD/MM/YYYY'), "DD/MM/YYYY");

            this.momentDataTerminoAntecipado = date;
            this.solicitacaoMudancaPrazo.dataTerminoProrrogada = date.toJSON();
            this.dataTerminoAntecipadoValidacao = date.format('DD/MM/YYYY');
        } else {
            this.solicitacaoMudancaPrazo.dataTerminoProrrogada = null;
            this.dataTerminoAntecipadoValidacao = null;
            this.momentDataTerminoAntecipado = null;
        }
    };

    // deprecated
    filtrarEmpregados(input, callback) {
        this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
            if(response && response.length > 0) {
                this.empregadosFiltrados.push(...response);
            }
            callback(null, {
                options: response.map(empregado => {
                    const cpf = !!empregado.cpf ?  " ("+empregado.cpf+")" : "";
                    return {value: input, label: empregado.matricula + " - " + empregado.nome + cpf};
                }),
                complete: false
            });
        }).catch(error => {
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    demandarAjustes(id) {
        if (id) {
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "AJUSTE", null, this.observacoes, this.detalhesTarefa)
        }
    }

    rejeitar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "REJECT", null, this.observacoes, this.detalhesTarefa)
        }
    }

    aprovar(id) {

        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
            }
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "APPROVE", null, this.observacoes, this.detalhesTarefa, this.apenasMatriculaAprovadoresExtraValidos);
        }
    }

    enviar(id) {
        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
            }
            return this.tarefaService.enviar(id, this.nomeFluxo, this.idSolicitacao, this.observacoes, this.detalhesTarefa, this.apenasMatriculaAprovadoresExtraValidos);
        }
    }

    desistir(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "DESISTIR", this.confirmarAlocacaoETT.razaoDesistencia, this.observacoes, this.detalhesTarefa)
        }
    }

    reivindicar(id) {
        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                if(!this.solicitacaoEtt.informarSalarioDiferente)
                    this.solicitacaoEtt.salarioDiferente = null;
                if(this.solicitacaoEtt.dadosMot.momentDataNascimento !== null && this.solicitacaoEtt.dadosMot.momentDataNascimento !== "")
                    this.solicitacaoEtt.dadosMot.dataNascimento = this.solicitacaoEtt.dadosMot.momentDataNascimento.toJSON();
                this.detalhesTarefa.solicitacaoEtt = this.solicitacaoEtt;
            }
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "REIVINDICAR", null, this.observacoes, this.detalhesTarefa);
        }
    }

    cancelar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "CANCELAR", null, this.observacoes, this.detalhesTarefa)
        }
    }

    confirmarContratacao(id) {

        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
            }
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "CONFIRMAR_CONTRATACAO", null, this.observacoes, this.detalhesTarefa);
        }
    }

    confirmarAlocacao(id) {
        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                if(!this.solicitacaoEtt.informarSalarioDiferente)
                    this.solicitacaoEtt.salarioDiferente = null;
                if(this.solicitacaoEtt.dadosMot.momentDataNascimento !== null && this.solicitacaoEtt.dadosMot.momentDataNascimento !== "")
                    this.solicitacaoEtt.dadosMot.dataNascimento = this.solicitacaoEtt.dadosMot.momentDataNascimento.toJSON();
                this.detalhesTarefa.solicitacaoEtt = this.solicitacaoEtt;
            }
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "CONFIRMAR_ALOCACAO", null, this.observacoes, this.detalhesTarefa);
        }
    }

    forcarAprovacao() {
        let idSolicitacao = this.idSolicitacao;
        if (this.isFluxoTerminoAntecipado || this.isFluxoProrrogacao)
            idSolicitacao = this.solicitacaoMudancaPrazo.id;

        return this.tarefaService.forcarAprovacao(this.nomeFluxo, idSolicitacao, this.observacoes);
    }

    carregarJustificativasPeloMotivoInicial() {
        this.loadingPanelStore.setIsLoading("JustificativasPeloMotivoInicial", true);
        this.justificativaContratacaoService.listByMotivo(this.solicitacao.motivoContratacao).then(response => {
            this.justificativasContratacao = response.data;
            this.loadingPanelStore.setIsLoading("JustificativasPeloMotivoInicial", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("JustificativasPeloMotivoInicial", false);
            console.log(error);
        });
    }

    carregarProdutosPelaJustificativaInicial(setProdutosCallback) {
        const justificativa = this.solicitacao.justificativaContratacao;
        if (justificativa && justificativa.id) {
            if (_.get(justificativa, "justificativaAlocavel") !== "NAO") {
                let produtos = [];
                this.loadingPanelStore.setIsLoading("ProdutosPelaJustificativaInicial", true);
                this.produtoService.listByJustificativa(justificativa.id).then(response => {
                    produtos = response.data;
                    if(setProdutosCallback) {
                        setProdutosCallback(produtos)
                    } else {
                        this.produtos = response.data;
                    }
                    this.loadingPanelStore.setIsLoading("ProdutosPelaJustificativaInicial", false);
                }).catch(error => {
                    this.loadingPanelStore.setIsLoading("ProdutosPelaJustificativaInicial", false);
                    console.log(error);
                });
            } else {
                this.resetProduto();
            }
        } else {
            this.produtos = [];
            this.resetProduto();
        }
    }

    prepararSolicitacao(solicitacao) {

        this.produtoVigente = toJS(solicitacao.produto);
        solicitacao.momentDataInicio = moment(solicitacao.dataInicio);
        solicitacao.momentDataTermino = moment(solicitacao.dataTermino);
        solicitacao.motivoContratacao = solicitacao.justificativaContratacao.motivoContratacao;
        solicitacao.contatoGlobo = solicitacao.contatoGloboId ? solicitacao.contatoGlobo : {
            id: 0,
            "nome": "",
            "telefone": "",
            "email": ""
        };
        solicitacao.matriculaEmpregadosSubstituidos = _.get(solicitacao,"empregadosSubstituidos.length") > 0 ? solicitacao.matriculaEmpregadosSubstituidos : [""];
        solicitacao.matriculaAprovadoresExtra = _.get(solicitacao,"matriculaAprovadoresExtra.length") > 0 ? solicitacao.matriculaAprovadoresExtra : [""];

        solicitacao.localTrabalhoCodigo = _.get(solicitacao, "localTrabalho.codigo");
        solicitacao.localTrabalho.template = _.get(solicitacao, "localTrabalho.uf") + " - " + _.get(solicitacao, "localTrabalho.template");

    }

    resetProduto() {
        if (!getByAtribute(this.produtos, this.solicitacao.produtoId, "id")) {
            this.solicitacao.produtoId = "";
            this.solicitacao.produto = null;
        }
    }

    setSolicitacaoEtt(solicitacaoEtt) {
        if (solicitacaoEtt){
            if(!solicitacaoEtt.dadosMot) {
                solicitacaoEtt.dadosMot = {
                    cpf: "",
                    nome: "",
                    dataNascimento: null,
                    momentDataNascimento: "",
                    dataNascimentoValidacao: "",
                    email: "",
                    telefone: "",
                    identidade: "",
                    orgaoEmissor: "",
                    tipoSanguineo: "",
                    endereco: {
                        rua: "",
                        numero: "",
                        complemento: "",
                        bairro: "",
                        cidade: "",
                        uf: "",
                        cep: ""
                    },
                    genero: "",
                    nomeSocial: ""
                }
            } else{
                if(solicitacaoEtt.dadosMot.dataNascimento) {
                    solicitacaoEtt.dadosMot.momentDataNascimento = moment(new Date(solicitacaoEtt.dadosMot.dataNascimento), "DD/MM/YYYY");
                    solicitacaoEtt.dadosMot.dataNascimentoValidacao = moment(new Date(solicitacaoEtt.dadosMot.dataNascimento)).format('DD/MM/YYYY');
                } else {
                    solicitacaoEtt.dadosMot.momentDataNascimento = null;
                    solicitacaoEtt.dadosMot.dataNascimentoValidacao = null;
                }
            }
            if (!solicitacaoEtt.contatoEtt) {
                solicitacaoEtt.contatoEtt = {
                    nome: "",
                    telefone: "",
                    email: ""
                }
            }
            solicitacaoEtt.informarDataInicioDiferente = this.confirmarAlocacaoETT.dataInicioRequerida !== null;

            this.solicitacaoEtt = solicitacaoEtt;
            this.confirmarAlocacaoETT = solicitacaoEtt;

            extendObservable(this.confirmarAlocacaoETT, {razaoDesistencia: null});

            if(this.isTarefaHTConfirmarAlocacao) {
                this.setDadosMOTComoIndicacao();
            } /*else if (this.exibeContratosAnterioresEValidacoes) {
                this.setCPFReivindicacaoParaValidacao([solicitacaoEtt.dadosMot.cpf]);
            }*/

            if(solicitacaoEtt.dataInicioRequerida) {
                solicitacaoEtt.momentNovaDataInicio = moment(solicitacaoEtt.dataInicioRequerida);
                this.setNovaDataInicio(solicitacaoEtt.momentNovaDataInicio);
            }
        }
    }

    atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo(solicitacaoId) {
        if (solicitacaoId) {
            this.cargoService.getDetalhesBySolicitacaoId(solicitacaoId).then(response => {
                if(response.data) {
                    response.data.nome = this.solicitacao.cargo ? this.solicitacao.cargo.nome : "";
                    response.data.id = this.solicitacao.cargo ? this.solicitacao.cargo.id : "";
                    extendObservable(this.solicitacao.cargo, response.data);
                    this.solicitacao.cargo = response.data;
                }
                if(this.solicitacaoEtt.dadosMot.cpf && this.solicitacaoEtt.dadosMot.cpf.length === 11 && this.permiteEditarCPF) {
                    this.validarCpfMOT(this.solicitacaoEtt.dadosMot.cpf, this.setLoadingMOTCpf, this.atualizaDadosMotReivindicacaoContratosAntigo);
                }
            }).catch(error => {

            });
        }
        else {
            this.solicitacao.cargo = {};
        }
    }

    getComentarios() {
        if (this.idSolicitacao) {
            let tipoFluxo = this.isFluxoSolicitacao ? this.nomeFluxo : "GloboMOTSolicitacaoEtt";
            this.solicitacaoService.getHistorico(tipoFluxo, this.idSolicitacao).then(response => {
                this.comentarios = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    }

    getTarefasFluxo(){
        if (this.idSolicitacao) {
            this.tarefaService.getTarefasFluxo(this.nomeFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data !== "") {
                    this.tarefasFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    setRazaoSubstituicaoCPF(value) {
        this.solicitacaoEtt.razaoSubstituicao = value;
    }

    toggleUsarCpfDiferente() {
        this.solicitacaoEtt.cpfDiferenteInformado = !this.solicitacaoEtt.cpfDiferenteInformado;
        this.setDadosMOTComoIndicacao(true);
    }

    setTelefone(value) {
        this.solicitacaoEtt.dadosMot.telefone = value;
    }

    setCEP(value) {
        this.solicitacaoEtt.dadosMot.endereco.cep = value;
    }

    setEmail(value) {
        this.solicitacaoEtt.dadosMot.email = value;
    }

    setEnderecoBairro(value) {
        this.solicitacaoEtt.dadosMot.endereco.bairro = value;
    }

    setEnderecoCidade(value) {
        this.solicitacaoEtt.dadosMot.endereco.cidade = value;
    }

    setEnderecoComplemento(value) {
        this.solicitacaoEtt.dadosMot.endereco.complemento = value;
    }

    setEnderecoNumero(value) {
        this.solicitacaoEtt.dadosMot.endereco.numero = value;
    }

    setEnderecoRua(value) {
        this.solicitacaoEtt.dadosMot.endereco.rua = value;
    }

    setEnderecoUF(value) {
        this.solicitacaoEtt.dadosMot.endereco.uf = value;
    }

    setIdentidade(value) {
        this.solicitacaoEtt.dadosMot.identidade = value;
    }

    setNome(value) {
        this.solicitacaoEtt.dadosMot.nome = value;
    }

    setOrgaoEmissor(value) {
        this.solicitacaoEtt.dadosMot.orgaoEmissor = value;
    }

    setTipoSanguineo(value) {
        this.solicitacaoEtt.dadosMot.tipoSanguineo = value;
    }

    setSalarioDiferente(value) {
        this.solicitacaoEtt.salarioDiferente = value;
    }

    toggleInformarSalarioDiferente() {
        this.solicitacaoEtt.informarSalarioDiferente = !this.solicitacaoEtt.informarSalarioDiferente;
    }

    setContatoEttEmail(value) {
        this.solicitacaoEtt.contatoEtt.email = value;
    }

    setContatoEttNome(value) {
        this.solicitacaoEtt.contatoEtt.nome = value;
    }

    setContatoEttTelefone(value) {
        this.solicitacaoEtt.contatoEtt.telefone = value;
    }

    resetSolicitacaoEtt() {
        this.solicitacaoEtt = {
            cpfDiferenteInformado: false,
            razaoSubstituicao: "",
            razaoAtraso: "",
            razaoDesistencia: "",
            indicacao: null,
            informarSalarioDiferente: false,
            salarioDiferente: null,
            dataInicioRequerida: null,
            temIndicacao: false,
            contatoEtt: {
                nome: "",
                telefone: "",
                email: ""
            },
            dadosMot: {
                cpf: "",
                nome: "",
                dataNascimento: null,
                momentDataNascimento: "",
                dataNascimentoValidacao: "",
                email: "",
                telefone: "",
                identidade: "",
                orgaoEmissor: "",
                tipoSanguineo: "",
                endereco: {
                    rua: "",
                    numero: "",
                    complemento: "",
                    bairro: "",
                    cidade: "",
                    uf: "",
                    cep: ""
                },
                genero: "",
                nomeSocial: ""
            }
        }
    }


    toggleInformarDataInicioDiferente = () => {
        this.confirmarAlocacaoETT.informarDataInicioDiferente = !this.confirmarAlocacaoETT.informarDataInicioDiferente;
    };

    forcarAlteracaoDataInicio = () => {
        this.confirmarAlocacaoETT.informarDataInicioDiferente = true;
        // Ao forçar, preenchemos a nova data com a data de início original para que o usuário seja obrigado a alterar.
        this.confirmarAlocacaoETT.dataInicioRequerida = this.solicitacao.momentDataInicio.toJSON();
    };

    setDataTerminoAntecipadoCheck = (value) => {
        this.dataTerminoAntecipadoValidacao = value;
    };

    setDataInicioCheck = (value) => {
        if(value) {
            let startDate = moment(value, "DD/MM/YYYY");
            let hoje = moment().startOf('day');
            this.dataInicioValidacao = value;
            if( startDate >= hoje && startDate.valueOf() !== this.solicitacao.momentDataInicio.valueOf() ) {
                const quantidadeDiasCorrente = this.quantidadeDias;
                this.solicitacao.momentDataInicio = startDate;
                this.solicitacao.momentDataTermino = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY").add(quantidadeDiasCorrente - 1, 'days');
                this.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
                this.detalhesTarefa.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
                if( this.solicitacaoEtt.dadosMot) {
                    const cpf = this.solicitacaoEtt.dadosMot.cpf
                    this.setMotCpf(cpf);
                }
            }
        }
    };

    setNovaDataInicioCheck = (value) => {
        if(value) {
            let startDate = moment(value, "DD/MM/YYYY");
            const quantidadeDiasCorrente = this.quantidadeDias;

            const avaliarCPF = this.solicitacaoEtt.dadosMot && 
                            ((startDate < this.solicitacao.momentDataInicio && this.confirmarAlocacaoETT.momentNovaDataInicio && startDate.valueOf() !== this.confirmarAlocacaoETT.momentNovaDataInicio.valueOf())
                            || (this.obstrucaoValidacaoCPF && this.confirmarAlocacaoETT.momentNovaDataInicio  && startDate.valueOf() !== this.confirmarAlocacaoETT.momentNovaDataInicio.valueOf()));

            this.dataInicioValidacao = value;
            this.confirmarAlocacaoETT.momentNovaDataInicio = startDate;
            this.confirmarAlocacaoETT.dataInicioRequerida = startDate.toJSON();
            this.solicitacao.momentDataTermino = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY").add(quantidadeDiasCorrente-1, 'days');
            this.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
            this.detalhesTarefa.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();

            if (avaliarCPF) {
                const cpf = this.solicitacaoEtt.dadosMot.cpf
                this.setMotCpf(cpf, true);
            }
        }
    };

    setDataNascimentoCheck = (value) => {
        this.solicitacaoEtt.dadosMot.dataNascimentoValidacao = value;
    };

    setNovaDataInicio = (value) => {
        let date = value;
        const quantidadeDiasCorrente = this.quantidadeDias;
        date = moment(date.format('DD/MM/YYYY'), "DD/MM/YYYY")
        this.confirmarAlocacaoETT.momentNovaDataInicio = date;

        this.alertaValidacaoCPF = null;
        this.obstrucaoValidacaoCPF = null;
        if (value) {
            this.confirmarAlocacaoETT.dataInicioRequerida = date.toJSON();
            //if(this.confirmarAlocacaoETT.momentNovaDataInicio < this.solicitacao.momentDataInicio) {
                this.solicitacao.momentDataTermino = moment(value.format('DD/MM/YYYY'), "DD/MM/YYYY").add(quantidadeDiasCorrente-1, 'days');
                this.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
                if(this.detalhesTarefa) {
                    this.detalhesTarefa.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
                }
                if( this.solicitacaoEtt.dadosMot && this.confirmarAlocacaoETT.momentNovaDataInicio < this.solicitacao.momentDataInicio) {
                    const cpf = this.solicitacaoEtt.dadosMot.cpf
                    this.setMotCpf(cpf, true);
                }
            /*} else {
                if(this.quantidadeDiasInicial)
                    this.solicitacao.momentDataTermino = this.solicitacao.momentDataInicio.clone().add(this.quantidadeDiasInicial-1, 'days');
                this.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
                this.detalhesTarefa.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
            }*/
            this.dataInicioValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.confirmarAlocacaoETT.dataInicioRequerida = null;
        }
    };

    setRazaoAtraso = (value) => {
        this.confirmarAlocacaoETT.razaoAtraso = value;
    };

    setRazaoDesistenciaAlocacaoETT = (value) => {
        this.confirmarAlocacaoETT.razaoDesistencia = value;
    };

    toggleConfirmacaoModalEtt = () => {
        this.confirmacaoModalEtt = !this.confirmacaoModalEtt;
    };

    //confirmar contratacao ett
    resetConfirmarAlocacaoETT = () => {
        this.confirmarAlocacaoETT = {
            informarDataInicioDiferente: false,
            momentNovaDataInicio: null,
            dataInicioRequerida: null,
            razaoAtraso: null,
            razaoDesistencia: null
        }
    };

    setValidacoes = (novasValidacoes) => {
        this.validacoes = novasValidacoes;
    };

    setContratos = (novosContratos) => {
        this.contratos = novosContratos;
    };

    setLoadingMOTCpf = (value) => {
        this.loadingCpfMOT = value;
    };

    carregarCpfMOT = (tipo) => {
        let cpf = null;
        if(tipo === "mot") {
            cpf = _.get(this.solicitacao, "indicacoes[0].cpf")
        } else if(tipo === "ett") {
            cpf = _.get(this.solicitacaoEtt.dadosMot, "cpf")
        }
        if(cpf) {
            const consultaCpf = {
                cpf: cpf,
                dataInicioContrato: moment(this.solicitacao.momentDataInicio).format('DD/MM/YYYY'),
                nomeCargo: _.get(this.solicitacao.cargo, "nome"),
                propostaSalario: this.solicitacao.solicitacaoExcecao ? this.solicitacao.salarioExcecao : _.get(this.solicitacao.cargo, "salarioBase"),
                cargoId: this.solicitacao.cargoId,
                empresaGloboId: this.solicitacao.localContratacaoId,
                solicitacaoExcecao: this.solicitacao.solicitacaoExcecao,
                solicitacaoId: _.get(this.solicitacao,"id"),
                solicitacaoEttId: _.get(this.solicitacaoEtt,"idSolicitacaoEtt")
            };
            var self = this;

            this.motService.validarCpf(consultaCpf).then(response => {
                let dadosValidacao = response.data;

                dadosValidacao.dataFimQuarentenaExFuncionario = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExFuncionario);
                dadosValidacao.dataFimQuarentenaExMOT = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExMOT);
                dadosValidacao.dataFimQuarentenaExPSP = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExPSP);

                let cpfFormatado = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");

                let ultimoSalario = false;
                let cargoDiferente = false;
                let valor = "";

                let validacoesFiltradas = Object.keys(dadosValidacao).map(function (key) {
                    if (dadosValidacao[key] === true) {
                        if(key == "ultimoSalarioMaiorProposta"){
                            ultimoSalario = true;
                        }
                        else if(key == "cargoDiferenteAnterior"){
                            cargoDiferente = true;
                        }
                        else{
                            valor = "";
                            switch (key){
                                case 'exPSP':
                                    valor = "Ex-PSP";
                                    break;
                                case 'exMOT':
                                    valor = "Ex-MOT";
                                    break;
                                case 'exFuncionario':
                                    valor = "Ex-funcionário";
                                    break;
                                case 'recorrenciaFormaContratacaoDiferente':
                                    valor = "Quarentena por recorrência em formato de contratação diferente";
                                    break;
                                case 'recorrenciaContratosConsecutivos':
                                    valor = "Quarentena por contratos consecutivos";
                                    break;
                                case 'recorrenciaAlocacao':
                                    valor = "Quarenta por recorrência de alocação";
                                    break;
                                case 'recursoNovo':
                                    valor = "Recurso novo";
                                    break;
                                case 'existeContratoVigente':
                                    valor = "Existe contrato vigente";
                                    break;
                                case 'quarentenaExPSP':
                                    valor = "Ex-PSP em quarentena";
                                    break;
                                case 'quarentenaExMOT':
                                    valor = "Ex-MOT em quarentena";
                                    break;
                                case 'quarentenaExFuncionario':
                                    valor = "Ex-funcionário em quarentena";
                                    break;
                            }

                            if(valor.length > 0){
                                return {cpf: cpfFormatado, key: valor};
                            }
                        }
                    }
                }).filter(item => item != null);

                if(ultimoSalario && !cargoDiferente){
                    validacoesFiltradas.push({cpf: cpfFormatado, key: "Mesmo cargo e salário anterior maior que proposta"});
                }

                if (validacoesFiltradas.length > 0) {
                    self.setValidacoes(validacoesFiltradas);
                }

                if (dadosValidacao.contratosAnteriores && dadosValidacao.contratosAnteriores.length) {
                    self.setContratos(dadosValidacao.contratosAnteriores);
                }

                self.alertaValidacaoCPF = response.data.alertaValidacaoCPF;
                self.obstrucaoValidacaoCPF = response.data.obstrucaoValidacaoCPF;

                if(dadosValidacao.alertaValidacao != null && dadosValidacao.alertaValidacao != undefined ){
                    self.alertas = dadosValidacao.alertaValidacao;
                }

            }).catch(error => {
                console.log(error);
            });
        }
    }

    validarCpfMOT = (cpf, funcaoSetLoadingValidacao, funcaoAtualizaDadosMOT, isNovaDataInicio = false) => {
        const consultaCpf = {
            cpf: cpf,
            dataInicioContrato: isNovaDataInicio ? this.confirmarAlocacaoETT.momentNovaDataInicio.format('DD/MM/YYYY') : moment(this.solicitacao.momentDataInicio).format('DD/MM/YYYY'),
            nomeCargo: _.get(this.solicitacao.cargo, "nome"),
            propostaSalario: this.solicitacao.solicitacaoExcecao ? this.solicitacao.salarioExcecao : _.get(this.solicitacao.cargo, "salarioBase"),
            cargoId: this.solicitacao.cargoId,
            empresaGloboId: this.solicitacao.localContratacaoId,
            solicitacaoExcecao: this.solicitacao.solicitacaoExcecao,
            solicitacaoId: _.get(this.solicitacao,"id"),
            solicitacaoEttId: _.get(this.solicitacaoEtt,"idSolicitacaoEtt")
        };
        funcaoSetLoadingValidacao(true);
        this.motService.validarCpf(consultaCpf).then(response => {
            let dadosValidacao = response.data;

            dadosValidacao.dataFimQuarentenaExFuncionario = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExFuncionario);
            dadosValidacao.dataFimQuarentenaExMOT = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExMOT);
            dadosValidacao.dataFimQuarentenaExPSP = formatarDataMilisegundos(dadosValidacao.dataFimQuarentenaExPSP);

            let cpfFormatado = formatarCpf(cpf);

            let ultimoSalario = false;
            let cargoDiferente = false;
            let valor = "";

            let validacoesFiltradas = Object.keys(dadosValidacao).map(function (key) {
                if (dadosValidacao[key] === true) {
                    if(key == "ultimoSalarioMaiorProposta"){
                        ultimoSalario = true;
                    }
                    else if(key == "cargoDiferenteAnterior"){
                        cargoDiferente = true;
                    }
                    else{
                        valor = "";
                        switch (key){
                            case 'exPSP':
                                valor = "Ex-PSP";
                                break;
                            case 'exMOT':
                                valor = "Ex-MOT";
                                break;
                            case 'exFuncionario':
                                valor = "Ex-funcionário";
                                break;
                            case 'recorrenciaFormaContratacaoDiferente':
                                valor = "Quarentena por recorrência em formato de contratação diferente";
                                break;
                            case 'recorrenciaContratosConsecutivos':
                                valor = "Quarentena por contratos consecutivos";
                                break;
                            case 'recorrenciaAlocacao':
                                valor = "Quarenta por recorrência de alocação";
                                break;
                            case 'recursoNovo':
                                valor = "Recurso novo";
                                break;
                            case 'existeContratoVigente':
                                valor = "Existe contrato vigente";
                                break;
                            case 'quarentenaExPSP':
                                valor = "Ex-PSP em quarentena";
                                break;
                            case 'quarentenaExMOT':
                                valor = "Ex-MOT em quarentena";
                                break;
                            case 'quarentenaExFuncionario':
                                valor = "Ex-funcionário em quarentena";
                                break;
                        }

                        if(valor.length > 0){
                            return {cpf: cpfFormatado, key: valor};
                        }
                    }
                }
            }).filter(item => item != null);

            if(ultimoSalario && !cargoDiferente){
                validacoesFiltradas.push({cpf: cpfFormatado, key: "Mesmo cargo e salário anterior maior que proposta"}) ;
            }

            if (validacoesFiltradas.length > 0) {
                this.setValidacoes(validacoesFiltradas);
            }

            if (dadosValidacao.contratosAnteriores && dadosValidacao.contratosAnteriores.length) {
                this.setContratos(dadosValidacao.contratosAnteriores);
            }

            if(dadosValidacao.dadosMot != null && dadosValidacao.dadosMot!= undefined){
                dadosValidacao.dadosMot.momentDataNascimento = dadosValidacao.dadosMot.dataNascimento ? moment(new Date(dadosValidacao.dadosMot.dataNascimento), "DD/MM/YYYY") : null;
                funcaoAtualizaDadosMOT(dadosValidacao.dadosMot);
            }

            this.alertaValidacaoCPF = response.data.alertaValidacaoCPF;
            this.obstrucaoValidacaoCPF = response.data.obstrucaoValidacaoCPF;

            if(dadosValidacao.alertaValidacao != null && dadosValidacao.alertaValidacao != undefined ){
                this.alertas = dadosValidacao.alertaValidacao;
            }


            funcaoSetLoadingValidacao(false);
        }).catch(error => {
            funcaoSetLoadingValidacao(false);
        });
    };

    atualizaDadosMotReivindicacaoContratosAntigo = (dadosAntigos) => {
        this.atualizaDadosMotContratosAntigo(this.solicitacaoEtt.dadosMot, dadosAntigos);
    };

    atualizaDadosMotContratosAntigo = (objetoParaAtualizar, dadosAntigos) =>{
        if(objetoParaAtualizar && dadosAntigos) {
            extendObservable(objetoParaAtualizar, dadosAntigos);
        }

    };

    limpaDadosMot = () => {
        this.alertas = "";
        this.contratos = [];
        this.validacoes = [];
        this.solicitacaoEtt.dadosMot.email = "";
        this.solicitacaoEtt.dadosMot.nome = "";
        this.solicitacaoEtt.dadosMot.dataNascimento = null;
        this.solicitacaoEtt.dadosMot.momentDataNascimento = "";
        this.solicitacaoEtt.dadosMot.dataNascimentoValidacao =  "",
        this.solicitacaoEtt.dadosMot.telefone = "";
        this.solicitacaoEtt.dadosMot.identidade = "";
        this.solicitacaoEtt.dadosMot.orgaoEmissor = "";
        this.solicitacaoEtt.dadosMot.tipoSanguineo= "";
        this.solicitacaoEtt.dadosMot.endereco.rua = "";
        this.solicitacaoEtt.dadosMot.endereco.numero = "";
        this.solicitacaoEtt.dadosMot.endereco.complemento  = "";
        this.solicitacaoEtt.dadosMot.endereco.bairro = "";
        this.solicitacaoEtt.dadosMot.endereco.cidade = "";
        this.solicitacaoEtt.dadosMot.endereco.uf = "";
        this.solicitacaoEtt.dadosMot.endereco.cep = "";
        this.solicitacaoEtt.dadosMot.genero = "";
        this.solicitacaoEtt.dadosMot.nomeSocial = "";
    };

    setMomentDataNascimento(value) {
        if (value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            this.solicitacaoEtt.dadosMot.momentDataNascimento = startDate;
            this.solicitacaoEtt.dadosMot.dataNascimentoValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.solicitacaoEtt.dadosMot.momentDataNascimento = null;
            this.solicitacaoEtt.dadosMot.dataNascimentoValidacao = null;
        }
    }

    setMomentDataInicio(value) {
        if (value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            const quantidadeDiasCorrente = this.quantidadeDias;
            this.solicitacao.momentDataInicio = startDate;

            this.alertaValidacaoCPF = null;
            this.obstrucaoValidacaoCPF = null;
            if (startDate != null && startDate.length !== 0) {
                this.solicitacao.dataInicio = startDate.toJSON();
                this.detalhesTarefa.solicitacao.dataInicio = startDate.toJSON();
            } else {
                this.solicitacao.dataInicio = null;
            }
            this.dataInicioValidacao = moment(value).format('DD/MM/YYYY');
            this.solicitacao.momentDataTermino = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY").add(quantidadeDiasCorrente-1, 'days');
            this.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();
            this.detalhesTarefa.solicitacao.dataTermino = this.solicitacao.momentDataTermino.toJSON();

            if( this.solicitacaoEtt.dadosMot) {
                const cpf = this.solicitacaoEtt.dadosMot.cpf
                this.setMotCpf(cpf);
            }
        } else {
            this.solicitacao.dataInicio = null;
            //this.solicitacao.momentDataInicio = null;
            this.dataInicioValidacao = null;
        }
    }
    getAlocacoesProdutoMot(solicitacaoEttId) {
        this.alocacoesProdutoMot = [];
        if (solicitacaoEttId) {
            this.solicitacaoService.carregarAlocacoesProdutoMot(solicitacaoEttId).then(response => {
                this.alocacoesProdutoMot = response.data;
            }).catch(error => {
            })
        }
    }

    setGenero(value){
        this.solicitacaoEtt.dadosMot.genero = value;
    }

    setNomeSocial(value){
        this.solicitacaoEtt.dadosMot.nomeSocial = value;
    }

    _filtrarProdutosPorTermo = (input, callback) => {
        if (typeof input !== 'string' && input.id > 0) {
            return null; //callback(null, { options: input }, true);
        }else if (typeof input !== 'string' || !input || input.length < 3) {
            return callback(null, { options: null });
        } 
        this.produtoService.searchByTermo(input)
            .then(response => {
                this.produtos = [];
                const produtos = response.data;
                const options = produtos.map(produto => {
                        const codigo = produto.codigo ? " (" + produto.codigo + ")" : "";
                        produto.label = produto.nome + codigo;
                        this.produtos.push(produto);
                        return produto;
                    })
                callback(null, { options: options, complete: true });
            })
            .catch(error => {
                console.error("Erro ao buscar produtos:", error);
                callback(error, { options: [] });
            });
    };
}